import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortByField',
    pure: true,
})
export class SortByFieldPipe implements PipeTransform {
    transform<T>(array: T[] | null | undefined, field: keyof T): T[] {
        if (!array || !field) {
            return [];
        }
        return [...array].sort((a, b) =>
            String(a[field]).localeCompare(String(b[field])),
        );
    }
}
